import { SystemStyleObject } from '@chakra-ui/react';
import { CSSProperties } from 'react';

export const getStyles = ({ isMobile }: { isMobile: boolean }) =>
  ({
    container: {
      ...(isMobile
        ? {}
        : {
            p: 12,
            w: 496,
            bg: 'M.10',
            rounded: 6,
            border: '1px solid',
            borderColor: 'M.30',
          }),
    },
    logo: {
      color: 'textBase',
      outline: 'none',
      width: '224px',
      height: '44px',
    },
    form: {
      w: 'full',
      alignItems: 'start',
    },
    centeredContainerSx: isMobile
      ? {}
      : { justifyContent: 'center', _before: {} },
  } as { [key: string]: SystemStyleObject });

export const bgPatternSx = {
  position: 'absolute',
  top: 0,
  zIndex: -1,
  width: '100%',
  height: '100%',
  color: 'var(--chakra-colors-M-30)',
} as { [key: string]: CSSProperties };
